import type ISchool from '../../../models/pa-egna-ben/school.model';
import MunicipalityApiModel from './municipality.api-model';
import ParticipationApiModel from './participation.api-model';

export default class SchoolApiModel {
  public id!: number;
  public municipalityGid!: string;
  public municipality?: MunicipalityApiModel;
  public name!: string;
  public streetAddress!: string;
  public postalCode!: string;
  public city!: string;
  public participations?: ParticipationApiModel[];

  public static mapToBusinessModel(apiModel: SchoolApiModel): ISchool {
    return {
      id: apiModel.id,
      municipalityGid: apiModel.municipalityGid,
      municipality: apiModel.municipality ? MunicipalityApiModel.mapToBusinessModel(apiModel.municipality) : undefined,
      name: apiModel.name,
      streetAddress: apiModel.streetAddress,
      postalCode: apiModel.postalCode,
      city: apiModel.city,
      participations: apiModel.participations ? apiModel.participations.map(ParticipationApiModel.mapToBusinessModel) : undefined,
    };
  }

  public static mapToApiModel(businessModel: ISchool): SchoolApiModel {
    if (businessModel.municipalityGid === undefined) {
      throw new Error('municipalityGid is required');
    }
    return {
      id: businessModel.id,
      municipalityGid: businessModel.municipalityGid,
      municipality: businessModel.municipality ? MunicipalityApiModel.mapToApiModel(businessModel.municipality) : undefined,
      name: businessModel.name,
      streetAddress: businessModel.streetAddress,
      postalCode: businessModel.postalCode.replace(/\s/g, ''),
      city: businessModel.city,
      participations: undefined,
    };
  }
}
